export const workbook = dataFromBackend => ({
  actions: [
    {
      description: 'Submit data to webhook.site',
      label: 'Submit foreground',
      mode: 'foreground',
      operation: 'submitActionFg',
      primary: true,
    },
  ],
  labels: ['pinned'],
  name: dataFromBackend?.name,
  sheets: [
    {
      fields: dataFromBackend.fields?.map(field => ({
        constraints: field.constraints,
        description: field.description,
        key: field.key,
        label: field.label,
        type: field.type,
      })),
      name: 'Contacts',
      slug: dataFromBackend?.slug,
    },
  ],
});
